export default __webpack_public_path__ + "static/mouse.opt-9507d21ebc950a844784e0e1902c7923.gif";